import { http } from '../api/client';
import { API_BASE } from '../auth/identity';

const base = API_BASE.replace(/\/dash$/, '') + '/dash/portfolios';
const config = { baseURL: base };

export interface PortfolioPart {
  customer_id: string;
  vertical: string;
  not_met: number | null;
  open: number | null;
  settled: number | null;
  results_held: boolean;
  expiries_due: number;
  people_count: number;
  location_count: number;
  states: string[];
  exceptions: Record<string, number>;
  binder: { label: string; created_at: string; review_status: string; signed_at: string | null } | null;
}

export interface PortfolioPractice {
  id: string;
  name: string;
  parts: PortfolioPart[];
  not_met: number;
  open: number;
  settled: number;
  expiries_due: number;
  people_count: number;
  location_count: number;
  states: string[];
  results_held: boolean;
  exceptions: Record<string, number>;
}

export interface PortfolioView {
  id: string;
  name: string;
  practices: PortfolioPractice[];
}

export const portfolioApi = {
  async create(name: string): Promise<{ id: string }> {
    const { data } = await http.post('', { name }, config);
    return data;
  },
  async addMember(id: string, customerId: string): Promise<void> {
    await http.post(`/${id}/members`, { customer_id: customerId }, config);
  },
  async removeMember(id: string, customerId: string): Promise<void> {
    await http.delete(`/${id}/members/${customerId}`, config);
  },
  async grant(id: string, userId: string): Promise<void> {
    await http.post(`/${id}/access`, { user_id: userId }, config);
  },
  async invite(id: string, email: string): Promise<{ email: string; invited: boolean }> {
    const { data } = await http.post(`/${id}/invite`, { email }, config);
    return data;
  },
  async access(id: string): Promise<{ user_id: string; email: string }[]> {
    const { data } = await http.get(`/${id}/access`, config);
    return data;
  },
  async revoke(id: string, userId: string): Promise<void> {
    await http.delete(`/${id}/access/${userId}`, config);
  },
  async list(): Promise<{ id: string; name: string }[]> {
    const { data } = await http.get('', config);
    return data;
  },
  async get(id: string): Promise<PortfolioView> {
    const { data } = await http.get(`/${id}`, config);
    return data;
  },
  async download(id: string, customerId: string, format: 'csv' | 'pdf'): Promise<void> {
    const { data } = await http.get(`/${id}/diligence/${customerId}.${format}`, {
      ...config, responseType: 'blob',
    });
    const url = URL.createObjectURL(data as Blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = format === 'csv' ? 'practice-diligence.csv' : 'practice-diligence-summary.pdf';
    document.body.append(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  },
};
